export const CLOSE_CAMPAIGN_PLACE_EDITOR = 'CLOSE_CAMPAIGN_PLACE_EDITOR';
export type CLOSE_CAMPAIGN_PLACE_EDITOR = typeof CLOSE_CAMPAIGN_PLACE_EDITOR;

export interface CloseCampaignPlaceEditor {
    type: CLOSE_CAMPAIGN_PLACE_EDITOR;
    editorId: string;
}

export function closeCampaignPlaceEditorAction(editorId: string): CloseCampaignPlaceEditor {
    return {
        type: CLOSE_CAMPAIGN_PLACE_EDITOR,
        editorId
    };
}
